import { render, staticRenderFns } from "./siswaTidakTerdaftar.vue?vue&type=template&id=0a2e7736"
import script from "./siswaTidakTerdaftar.vue?vue&type=script&lang=js"
export * from "./siswaTidakTerdaftar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports